import React, { useState } from "react";
import classNames from "classnames";
import CapitalSettingsGrid from "./Capital/CapitalSettingsGrid";
import { PaymentMethodRestrictions } from "../RestrictionSettings";
import FunderSettings from "./FunderSettings/FunderSettings";
import { AssignmentLetterSettings } from "./Capital/AssignmentLetterSettings";
import {
  FunderType,
  FunderTypeDescription,
  FunderTypeCssClass,
  CalcTableType,
  CalcTableTypeDescription,
} from "features/../../../shared/constants/enums";

const CapitalSettings = ({ settingsId, calcTableType }) => {
  const [expandCapitalSettingGrid, setExpandCapitalSettingGrid] =
    useState(false);
  const [expandPaymentMethodRestrictions, setExpandPaymentMethodRestrictions] =
    useState(false);
  const [expandCoFunderSoftwareCFA, setExpandCoFunderSoftwareCFA] =
    useState(false);
  const [expandCoFunderCFA, setExpandCoFunderCFA] = useState(false);
  const [expandFunderSoftwareCFA, setExpandFunderSoftwareCFA] = useState(false);
  const [expandFunderCFA, setExpandFunderCFA] = useState(false);
  const [expandSupplierSoftwareCFA, setExpandSupplierSoftwareCFA] =
    useState(false);
  const [expandSupplierCFA, setExpandSupplierCFA] = useState(false);
  const [expandAssignmentLetterSettings, setExpandAssignmentLetterSettings] =
    useState(false);

  const expandCfaMappings = [
    {
      funderType: FunderType.Funder,
      calcTableType: CalcTableType.SoftwareAssignment,
      expand: expandFunderSoftwareCFA,
      setExpand: setExpandFunderSoftwareCFA,
    },
    {
      funderType: FunderType.Funder,
      calcTableType: CalcTableType.Standard,
      expand: expandFunderCFA,
      setExpand: setExpandFunderCFA,
    },

    {
      funderType: FunderType.Dealer,
      calcTableType: CalcTableType.SoftwareAssignment,
      expand: expandSupplierSoftwareCFA,
      setExpand: setExpandSupplierSoftwareCFA,
    },
    {
      funderType: FunderType.Dealer,
      calcTableType: CalcTableType.Standard,
      expand: expandSupplierCFA,
      setExpand: setExpandSupplierCFA,
    },

    {
      funderType: FunderType.CoFunded,
      calcTableType: CalcTableType.SoftwareAssignment,
      expand: expandCoFunderSoftwareCFA,
      setExpand: setExpandCoFunderSoftwareCFA,
    },
    {
      funderType: FunderType.CoFunded,
      calcTableType: CalcTableType.Standard,
      expand: expandCoFunderCFA,
      setExpand: setExpandCoFunderCFA,
    },
  ];

  const includeStandardCalcTable =
    Array.isArray(calcTableType) &&
    calcTableType.includes(CalcTableType.Standard);
  const includeSoftwareAssignmentCalcTable =
    Array.isArray(calcTableType) &&
    calcTableType.includes(CalcTableType.SoftwareAssignment);

  const funderTypeSettingsData = [];
  let index = 2;
  [FunderType.Funder, FunderType.Dealer, FunderType.CoFunded].forEach(
    (funderType) => {
      [CalcTableType.SoftwareAssignment, CalcTableType.Standard].forEach(
        (calcType) => {
          if (
            (calcType === CalcTableType.Standard && includeStandardCalcTable) ||
            (calcType === CalcTableType.SoftwareAssignment &&
              includeSoftwareAssignmentCalcTable)
          ) {
            funderTypeSettingsData.push({
              funderType,
              calcType,
              title: `${FunderTypeDescription[funderType]} ${
                Array.isArray(calcTableType) && calcTableType.length > 1
                  ? CalcTableTypeDescription[calcType]
                  : ""
              } CFA`,
              index: index,
              setExpand: expandCfaMappings.find(
                (mapping) =>
                  mapping.funderType === funderType &&
                  mapping.calcTableType === calcType,
              )?.setExpand,
              expand: expandCfaMappings.find(
                (mapping) =>
                  mapping.funderType === funderType &&
                  mapping.calcTableType === calcType,
              )?.expand,
              cssClass: classNames(FunderTypeCssClass[funderType], {
                "software-assignment":
                  calcType === CalcTableType.SoftwareAssignment,
              }),
              ref: expandCfaMappings.find(
                (mapping) =>
                  mapping.funderType === funderType &&
                  mapping.calcTableType === calcType,
              )?.ref,
            });
            index++;
          }
        },
      );
    },
  );

  return (
    <div className="capital-settings">
      <CapitalSettingsGrid
        settingsId={settingsId}
        collapsedOnLoad={false}
        expand={expandCapitalSettingGrid}
        setExpand={setExpandCapitalSettingGrid}
      />
      <br />
      <PaymentMethodRestrictions
        settingsId={settingsId}
        collapsedOnLoad={true}
        expand={expandPaymentMethodRestrictions}
        setExpand={setExpandPaymentMethodRestrictions}
      />

      {funderTypeSettingsData.map((data, i) => (
        <React.Fragment key={i}>
          <br />
          <FunderSettings
            settingsId={settingsId}
            collapsedOnLoad={true}
            title={data.title}
            type={data.funderType}
            calcTableType={data.calcType}
            cssClass={data.cssClass}
            setExpand={data.setExpand}
            expand={data.expand}
          />
        </React.Fragment>
      ))}

      <br />
      <AssignmentLetterSettings
        settingsId={settingsId}
        collapsedOnLoad={true}
        expand={expandAssignmentLetterSettings}
        setExpand={setExpandAssignmentLetterSettings}
      />
    </div>
  );
};

export default CapitalSettings;
